import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import { Input, Row, Card, Form, DatePicker, Col, Divider, Spin, Button, Space, Tooltip, Select } from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../components/layouts/TopContent";
// import { apiConfig, labelConfig, staticConfig } from "../../../../customer/customer.config";
import { apiConfig, labelConfig, staticConfig } from "../../../contractbooking.config";
import SuccessModal from "../../../component/SuccessModal";
import dayjs from "dayjs";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { useGetProdTemplate, useGetTreasuryItem } from "../../../../treasury/treasuryBill/hooks/useServerActions";
import { useGetTreasuryBillContract, useGetTreasuryBillContractTemplate } from "../../../hooks/useServerActions";
import { extractNumberFromText } from "../../../helper/helper";
import { Util } from "../helpers";
const { TextArea } = Input;
const AmendTreasuryBillContract = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { prodTemplate, loading: treasuryProdTemplateLoading } = useGetProdTemplate(session);
  const { contractTemplate, loading: contractTemplateIsLoading } = useGetTreasuryBillContractTemplate(session);
  const { contract, loading: contractLoading } = useGetTreasuryBillContract(session, state.key);
  const [derivedFormItems, setDerivedFormItems] = React.useState({});
  const tenor = Form.useWatch("tenor", form);
  const discountRate = Form.useWatch("discountRate", form);
  const selectedTenorValue = extractNumberFromText(Util.mapFormFieldToLabel("tenorOptions", tenor, prodTemplate)) ?? contract?.tenor;
  const issueDate = dayjs(contract?.issueDate);
  const faceValue = contract?.faceValue;
  const maturityDate = issueDate ? dayjs(issueDate).add(selectedTenorValue, "day") : undefined;

  console.log(derivedFormItems);
  function onCancel() {
    navigate("/view-contract-booking-treasury-bill", { state: state });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.EditTreasuryBillContract}/${state.key}`;
    // const params = {
    //   command: "approve",
    // };

    const body = {
      autoMaturityTransfer: contract?.autoMaturityTransfer,
      productId: contract?.product.id,
      clientId: String(contract?.client.id),
      linkedAccountId: contract?.linkedAccount?.id,
      targetAccountId: contract?.targetAccount?.id,
      faceValue: contract?.faceValue,
      purchasePrice: derivedFormItems?.purchasePrice ?? contract?.purchasePrice,
      yieldPercentage: derivedFormItems?.yieldPercentage ?? contract?.yieldPercentage,
      interestType: contract?.interestType.value,

      maturityValue: derivedFormItems?.maturityValue ?? contract?.maturityValue,
      withholdTax: contract?.withholdTax,
      centralBankReportingCode: contract?.centralBankReportingCode,
      amlScreening: contract?.amlScreening.value,
      kycValidated: contract?.kycValidated,
      centralBankAuctionRefLinked: contract?.centralBankAuctionRefLinked,
      auctionReference: contract?.auctionReference,
      allowRollover: contract?.allowRollover,
      autoRollover: contract?.autoRollover,
      maturityNarration: contract?.maturityNarration,
      issueDate: BOM.DateTime(contract?.issueDate, "only-date"),
      settlementDate: BOM.DateTime(derivedFormItems?.settlementDate ?? contract?.settlementDate, "only-date"),
      valueDate: BOM.DateTime(derivedFormItems?.valueDate ?? contract?.valueDate, "only-date"),
      submittedOnDate: BOM.DateTime(dayjs(), "only-date"),
      ...formValues,
      tenor: selectedTenorValue,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
      // params,
    };
    console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsModalVisible(true);
        // BOM.AlertMsg(cnt.SUCCESS, "Contract was approved");
        // navigate("/view-interbank-contract", {
        //   state: { ...state, statusValue: "approved" },
        // });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  const handleGoBack = () => {
    navigate("/view-contract-booking-treasury-bill", {
      state: { ...state, statusValue: "approved" },
    });
  };
  React.useEffect(() => {
    console.log("contract changes");
    form.setFieldsValue({
      tenor: contract?.tenor,
      discountRate: contract?.discountRate,
    });
  }, [contract]);

  React.useEffect(() => {
    const calculatedDiscountRate = discountRate / 100;
    const purchasePrice = Number(contract?.faceValue / (1 + calculatedDiscountRate));
    const daysToMaturity = selectedTenorValue;
    const yieldCalc1 = (contract?.faceValue - purchasePrice) / purchasePrice;
    const yieldCalc2 = (365 / daysToMaturity) * 100;
    const yieldResult = String(Number(yieldCalc1 * yieldCalc2).toFixed(2));
    setDerivedFormItems({
      ...derivedFormItems,
      maturityValue: contract?.faceValue ?? 0,
      purchasePrice: contract?.faceValue ? Number(purchasePrice).toFixed(2) : 0,
      yieldPercentage: contract?.faceValue ? yieldResult : 0,
      maturityDate: maturityDate,
      settlementDate: dayjs(maturityDate).add(1, "days"),
      valueDate: dayjs(maturityDate),
    });
    console.log(contract?.faceValue, calculatedDiscountRate, purchasePrice, yieldResult);
  }, [contract, discountRate, selectedTenorValue, tenor]);

  // React.useEffect(() => {
  //   setDerivedFormItems({ ...derivedFormItems, maturityDate: maturityDate, settlementDate: dayjs(maturityDate).add(1, "days"), valueDate: dayjs(maturityDate) });
  // }, [tenor]);

  console.log(faceValue);

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent pageTitle={"Amend Deal"} pageItems={[]} />

      <Spin spinning={isLoading || treasuryProdTemplateLoading || contractTemplateIsLoading || contractLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Maturity Tenor cannot be empty",
                    },
                  ]}
                  label={
                    <Space>
                      Maturity Tenor
                      <Tooltip title="Maturity Tenor">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </Space>
                  }
                  name={"tenor"}
                >
                  <Select
                    // size="large"
                    options={prodTemplate?.tenorOptions}
                    placeholder={"Select tenor"}
                    suffixIcon={<ChevronDown color="#667085" width={20} />}
                    className="custom-input read-only-select"
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Please enter discount rate",
                    },
                  ]}
                  label={
                    <Space>
                      Discount Rate (%)
                      <Tooltip title="Discount Rate(%)">
                        <InfoCircleOutlined />
                      </Tooltip>
                    </Space>
                  }
                  name={"discountRate"}
                >
                  <Input className="of-bold-disable-input" placeholder="9.25" style={{ height: "44px" }} suffix="%" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "15%",
                  padding: "8px",

                  width: "100%",
                }}
              >
                <Button
                  style={{
                    margin: "0 8px",
                    height: 44,
                    fontSize: 16,
                    background: "#FFFFFF",
                    borderColor: "#D0D5DD",
                  }}
                  onClick={onCancel}
                >
                  Cancel
                </Button>
                <Button
                  style={{
                    background: "#BA24D5",
                    borderColor: "#BA24D5",
                    height: 44,
                    fontSize: 16,
                    color: "white",
                  }}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </div>
              {/* <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              /> */}
            </Row>
          </Form>
        </Card>
        <SuccessModal visible={isModalVisible} onClose={handleGoBack} successMessage={"Contract amended successfully"} />
      </Spin>
    </MainLayout>
  );
};
export default AmendTreasuryBillContract;
